import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardDataWrapperMixin */
/** @method */
export var PropertyCardDataWrapperMixin = function PropertyCardDataWrapperMixin(props) {
  return token('PropertyCard.data.gap', function (columnGap) {
    return css(["align-content:start;display:grid;grid-area:data;grid-column-gap:", ";grid-template-areas:'title title actions' 'body1 body1 body1' 'body2 body2 body2' 'body3 mls-logo mls-logo' 'additionalInfo additionalInfo additionalInfo';grid-template-columns:1fr min-content;justify-content:space-between;"], columnGap ? columnGap + "px" : spaceMixin('xs')(props));
  })(props);
};